import utils from '../../../modules/utils';
import API from '../../api/api';

function isTokenReceived(status) {
  return status === 'KLARNA_TOKEN_RECEIVED';
}

function isReturningFromHostedPage(queryParams) {
  return !!utils.fn.getURIParam(queryParams, 'klarna');
}

function isProblemWithService(status) {
  return (status === 'KLARNA_AUTHENTICATION_FAILED'
    || status === 'KLARNA_CURRENTLY_UNAVAILABLE'
    || status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage() {
  return API.doAPIRequest('/v2/return-from-hosted/klarna');
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
